module.exports = __webpack_public_path__ + "static/media/KC.68ce8b84.svg";